import Vue from "vue";
import VueRouter from "vue-router";
import Page from "@/views/Page.vue";
import Error from "@/views/Error.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Page,
  },
  {
    path: "/index.html",
    redirect: (to) => {
      return { path: "/", query: to.query };
    },
  },
  {
    path: '/:path(.*)*',
    name: "notFound",
    component: Error,
    meta: {
      title: "404",
      isHide: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
